export const financeI18nEn = { FINANCE: {
  "BUYING_PRICE": "Buying price (excluding VAT)",
  "BUYING_CURRENCY": "Buying currency",

  "COMPLETION_TITLE": "Missing information",
  "COMPLETION_CUSTOMER": "Customer information",
  "COMPLETION_INVOICE": "Invoice information",
  "COMPLETION_LINE": "Line {{number}} · {{description}}",

  "SELECT_CUSTOMER": "Select customer",
  "CUSTOMER_MULTIPLE_MATCHES": "More than one customer has this tax/identity number. Select the correct customer from the list.",
  "CHANGE_CUSTOMER": "Change customer",
  "NEW_CUSTOMER": "New customer",
  "EDIT_CUSTOMER": "Edit customer",
  "SAVE_CUSTOMER": "Save customer",

  "PARASUT_INTEGRATION": "Paraşüt Integration",
  "FINANCE_SERVICE_OPEN": "Finance service available",
  "FINANCE_SERVICE_CLOSED": "Finance service unavailable",
  "FINANCE_SERVICE_CHECKING": "Checking Finance service…",
  "PARASUT_SERVER_PROBLEM": "Server issue",
  "PARASUT_CONNECTION_OPEN": "Connection active",
  "PARASUT_CONNECTION_CLOSED": "Connection inactive",
  "PARASUT_CONNECTION_UNVERIFIED": "Connection status unverified",
  "PARASUT_SERVERS_OPEN": "Paraşüt servers available",
  "PARASUT_SERVERS_CLOSED": "Paraşüt servers unavailable",
  "PARASUT_SERVERS_CHECKING": "Checking Paraşüt servers…",
  "PARASUT_SERVERS_UNCHECKED": "Paraşüt servers not checked",
  "PARASUT_SERVERS_UNVERIFIED": "Paraşüt server status unverified",
  "PARASUT_OPEN": "Paraşüt Connected",
  "PARASUT_CLOSED": "Paraşüt Disabled",
  "PARASUT_STATUS_LOADING": "Loading Paraşüt status…",
  "PARASUT_CONNECTING": "Connecting to Paraşüt…",
  "PARASUT_CALLBACK_CONNECTED": "Paraşüt connected successfully.",

  "RESOURCE_CONTACT": "Customer creation",
  "RESOURCE_PRODUCT": "Product/service creation",
  "RESOURCE_PRODUCT_UPDATE": "Product/service update",
  "COLLECTION_REJECTED": "Rejected",
  "PROVIDER_ROUTING_REQUIRED": "Complete the recipient tax/identity number to save the invoice and verify e-Invoice eligibility.",
  "PARASUT_CALLBACK_DENIED": "Paraşüt authorization was declined. Connect again when you are ready.",
  "USE_Official": "Previously invoiced",
  "STATUS_Cancelled": "Cancelled",
  "HISTORICAL_RECORD": "Historical invoice",
  "PARASUT_NOT_CONNECTED": "Not connected",
  "PARASUT_REFRESH_CATALOGUE": "Synchronize",
  "LOCAL_PREVIEW": "Preview · Unsaved changes",
  "PROVIDER_CONFIRMED_TOTALS": "Invoice totals",
  "DRAFT_PENDING_TITLE": "Draft request awaiting confirmation",
  "DRAFT_PENDING": "The draft request has not been confirmed. Verify its outcome before another save.",
  "DRAFT_VERIFY_NOT_APPLIED": "Verify that the request was not applied and release it for an explicit retry",
  "DRAFT_RETRY_REQUIRED": "The request was not applied. Review your entries and save again.",
  "DRAFT_RECOVERED": "The saved draft was recovered. Any further edits still require Save.",
  "LEGACY_LOCAL_DRAFTS": "Existing local drafts · Review required",
  "LEGACY_LOCAL_DRAFT_MESSAGE": "Saving these drafts has not been confirmed. Review their contents and save again.",
  "PARASUT_CONNECTED": "Connected",
  "PARASUT_NOT_CONFIGURED": "Paraşüt credentials must be configured on the server.",
  "PARASUT_DISCONNECT_MESSAGE": "Provider operations will stop. Local drafts and saved financial history remain available.",
  "PARASUT_DISCONNECT": "Disconnect",
  "PARASUT_RECONNECT": "Reconnect",
  "PARASUT_CONNECT": "Connect Paraşüt",
  "PARASUT_CONNECT_FAILED": "Could not change the Paraşüt connection. Try again.",
  "PARASUT_LOAD_FAILED": "Could not load Paraşüt connection status.",
  "PARASUT_CALLBACK_FAILED": "Paraşüt authorization failed or expired. Connect again.",
  "PROVIDER_MANAGE_TRANSACTION": "Manage this transaction in the connected accounting application",
  "RECONCILE_FAILED": "The record could not be verified. Check it in the connected accounting application.",
  "PROVIDER_RECONCILE": "Verify and link",
  "PROVIDER_RESOURCE_ID": "External record ID",
  "PROVIDER_INVOICE_ID": "External invoice ID",
  "PROVIDER_ATTENTION": "The transaction result needs review. Refresh or ask an administrator to verify it.",
  "PDF_FAILED": "The PDF is not available yet. Try again shortly.",
  "DOWNLOAD_PDF": "Download PDF",
  "OTV_CODE": "Excise duty code",
  "TEVKIFAT_CODE": "VAT withholding code",
  "INVALID_TEVKIFAT_CODE": "Select a VAT withholding code valid for the selected rate.",
  "TEVKIFAT_CONSTRUCTION": "Construction and related engineering, architecture, survey and project services",
  "TEVKIFAT_CONSULTANCY": "Survey, planning, project, consultancy, audit and similar services",
  "TEVKIFAT_MAINTENANCE": "Modification, maintenance and repair of machinery, equipment, fixtures and vehicles",
  "TEVKIFAT_CATERING": "Catering services",
  "TEVKIFAT_ORGANIZATION": "Event organization services",
  "TEVKIFAT_LABOUR": "Labour supply services",
  "TEVKIFAT_SECURITY": "Private security services",
  "TEVKIFAT_BUILDING_INSPECTION": "Building inspection services",
  "TEVKIFAT_TEXTILES": "Subcontracted textiles, clothing, bag and footwear production and related intermediary services",
  "TEVKIFAT_TOURIST_CUSTOMERS": "Customer referral and transport services for tourist shops",
  "TEVKIFAT_SPORTS_RIGHTS": "Sports clubs’ broadcasting, advertising and naming rights transactions",
  "TEVKIFAT_CLEANING": "Cleaning services",
  "TEVKIFAT_GARDENING": "Environmental and garden maintenance services",
  "TEVKIFAT_SHUTTLE": "Shuttle transport services",
  "TEVKIFAT_PRINTING": "All types of printing and press services",
  "TEVKIFAT_OTHER_SERVICES": "Other services [KDVGUT-(I/C-2.1.3.2.13)]",
  "TEVKIFAT_SCRAP_INGOTS": "Deliveries of ingots obtained from scrap metal",
  "TEVKIFAT_OTHER_INGOTS": "Deliveries of copper, zinc, iron, steel, aluminium and lead ingots other than those obtained from scrap metal",
  "TEVKIFAT_METAL_PRODUCTS": "Deliveries of copper, zinc and aluminium products",
  "TEVKIFAT_METAL_PRODUCTS_WITH_LEAD": "Deliveries of copper, zinc, aluminium and lead products",
  "TEVKIFAT_WAIVED_EXEMPTION_SCRAP": "Scrap and waste deliveries by suppliers waiving the exemption",
  "TEVKIFAT_RECYCLED_MATERIALS": "Deliveries of raw materials obtained from metal, plastic, tyre, rubber, paper and glass scrap and waste",
  "TEVKIFAT_RAW_FIBRES_HIDES": "Deliveries of cotton, mohair, wool, fleece, raw hides and skins",
  "TEVKIFAT_FORESTRY": "Deliveries of wood and forestry products",
  "TEVKIFAT_FREIGHT": "Freight transport services [KDVGUT-(I/C-2.1.3.2.11)]",
  "TEVKIFAT_ADVERTISING": "Commercial advertising services [KDVGUT-(I/C-2.1.3.2.15)]",
  "TEVKIFAT_OTHER_DELIVERIES": "Other deliveries [KDVGUT-(I/C-2.1.3.3.7)]",
  "TEVKIFAT_IRON_STEEL": "Deliveries of iron and steel products [KDVGUT-(I/C-2.1.3.3.8)]",
  "VAT_EXEMPTION_REASON": "VAT exemption explanation",
  "VAT_EXEMPTION_CODE": "Zero-VAT exemption code",
  "EINVOICE_INBOX": "e-Invoice inbox",
  "SCENARIO_COMMERCIAL": "Commercial",
  "SCENARIO_BASIC": "Basic",
  "EDOCUMENT_SCENARIO": "Approval process",
  "PROVIDER_REVIEW_REQUIRED": "Complete the electronic document settings",
  "PROVIDER_RECIPIENT_AMBIGUOUS": "Multiple active customers have the same tax/identity number. Review the customer records in the connected accounting application and try again.",
  "PROVIDER_RECIPIENT_UNRESOLVED": "The recipient match could not be verified. Review the recipient information and save the invoice again.",
  "SELECT": "Select",
  "COLLECTION_RATE_HEADER": "Exchange rate",
  "COLLECTION_STATUS_ACTIONS": "Status / Actions",
  "COLLECTION_LEAVE_UNCERTAIN": "The collection request may already have succeeded. Leaving this view does not cancel it. Check the collection history before recording another receipt.",
  "COLLECTION_RETRY": "Awaiting confirmation",
  "COLLECTION_UNCERTAIN": "The transaction result could not be confirmed. Refresh the history before recording another payment.",
  "COLLECTION_ACTION": "Collection",
  "COLLECTION_TITLE": "Invoice {{number}} · Collections",

  "COLLECTION_BACK": "Back to invoice",
  "COLLECTION_INVOICE_TOTAL": "Invoice total",
  "COLLECTION_COLLECTED": "Collected",
  "COLLECTION_REMAINING": "Remaining",
  "COLLECTION_ACCOUNT": "Collection account",
  "COLLECTION_SELECT_ACCOUNT": "Select account",
  "COLLECTION_DATE": "Collection date",
  "COLLECTION_AMOUNT": "Collection amount {{currency}}",
  "COLLECTION_RATE": "Exchange rate ({{from}} → {{to}})",
  "COLLECTION_SETTLEMENT": "Amount applied to invoice",
  "COLLECTION_HISTORY": "Collection history",
  "COLLECTION_NO_HISTORY": "No collections recorded yet.",
  "COLLECTION_LOADING": "Loading collections…",
  "COLLECTION_PAID": "This invoice is fully collected.",
  "COLLECTION_SAVE": "Record collection",
  "COLLECTION_SAVE_FAILED": "Could not complete the collection action. Your entries have been retained; review the history before retrying.",
  "COLLECTION_CONFLICT": "Collections have changed. Review the updated balance and history before trying again.",
  "COLLECTION_CANCEL": "Delete",
  "COLLECTION_CANCELLED": "Cancelled",
  "COLLECTION_CANCEL_TITLE": "Delete this collection?",
  "COLLECTION_CANCEL_MESSAGE": "The collection amount will be added back to the remaining invoice balance. The record will be retained in the transaction history.",
  "COLLECTION_DATE_INVALID": "Use a date between the invoice issue date and today.",
  "COLLECTION_OVERPAYMENT": "The collection cannot exceed the remaining invoice balance.",
  "COLLECTION_RELOAD": "Retry loading",
  "ARCHIVE": "Archive",
  "ARCHIVING": "Archiving",
  "ARCHIVE_PRODUCT_TITLE": "Archive product/service?",
  "ARCHIVE_PRODUCT_MESSAGE": "This product will disappear from selection. Saved invoices will remain unchanged; replace this product before saving or officializing an editable invoice.",
  "ARCHIVE_UNSAVED_MESSAGE": "Your unsaved product edits will not be saved.",
  "ARCHIVE_FAILED": "Could not archive this product. Check your connection and try again.",
  "ARCHIVE_CONFLICT": "This product or an affected invoice has changed. Reload the latest details before trying again.",
  "PRECISION_ERROR": "Use at most {{scale}} decimal places and {{integerDigits}} digits before the decimal separator.",
  "DATE_ORDER_ERROR": "The due date cannot be earlier than the issue date.",
  "WRITE_CONFLICT": "The invoice or its work items have changed. Review the current information and try again.",
  "DELETED_DRAFT": "This invoice draft was deleted in another session. Your entries have been retained, but this draft can no longer be saved.",
  "ADD_PRODUCT": "Add product/service",
  "PRODUCT_EDITOR": "Product/service",
  "PRODUCT_NAME": "Product name",
  "CODE": "Code",
  "OPTIONAL_CODE": "Code (Optional)",
  "UNIT": "Unit",
  "DEFAULT_PRICE": "Selling price",
  "CURRENCY": "Currency",
  "VAT_RATE": "VAT (%)",
  "person": "Individual",
  "company": "Company",
  "percentage": "Percentage",
  "amount": "Fixed",
  "CLOSE": "Close",
  "CANCEL": "Cancel",
  "DELETE": "Delete",
  "DELETE_INVOICE_TITLE": "Delete invoice draft?",
  "DELETE_INVOICE_MESSAGE": "This invoice draft will be deleted. This action cannot be undone.",
  "DELETE_FAILED": "Could not delete this invoice. Check your connection and retry.",
  "DELETE_CONFLICT": "This invoice has changed or is no longer a draft. Reload its latest details before trying again.",
  "SAVE": "Save",
  "SAVING": "Saving",
  "SAVE_FAILED": "Could not save. Check the fields and connection, then retry.",
  "PROVIDER_REQUEST_NOT_SENT": "The request was not sent. Your entries have been retained; wait briefly and try again.",
  "LOAD_FAILED": "Could not load this information. Please retry.",
  "RETRY": "Retry",
  "LOADING": "Loading",
  "SEARCH": "Search",
  "EDIT": "Edit",
  "UNSPECIFIED": "Unspecified",
  "ACTIONS": "Actions",
  "SELECT_PRODUCT": "Select or create product/service",
  "PRODUCT_SERVICE": "Product / Service",
  "INVALID_FIELD": "Please check this value.",
  "DISCOUNT_EXCEEDS_BASE": "The discount cannot exceed its applicable amount.",
  "CALCULATION_TOO_LARGE": "The entered amounts exceed the supported calculation range.",
  "REQUIRED_FIELD": "Complete this field: {{field}}.",
  "WORK_ORDER_NOT_APPROVED": "Work order {{field}} needs appraisal approval before invoice issuance.",
  "RECIPIENT": "Person / Company being invoiced",
  "PARTY_TYPE": "Recipient type",
  "RECIPIENT_NAME": "Full name / Company name",
  "TAX_NUMBER": "Tax / Identity number",
  "RECIPIENT_ABROAD": "Is the recipient abroad?",
  "NO": "No",
  "YES": "Yes",
  "TAX_OFFICE": "Tax office",
  "PHONE_COUNTRY_CODE": "Dialling code",
  "PHONE_COUNTRY_ISO": "Phone country ISO code",
  "PHONE": "Phone",
  "EMAIL": "Email",
  "ADDRESS": "Address",
  "CITY": "City",
  "DISTRICT": "District",
  "POSTAL_CODE": "Postal code",
  "COUNTRY": "Country",
  "INVOICES": "Invoices",
  "INVOICE_NUMBER": "Invoice {{number}}",
  "ITEM_COUNT": "Items: {{count}}",
  "CREATE_DRAFT": "Create draft",
  "INVOICE_EDITOR": "Invoice {{number}} · Edit Draft",
  "INVOICE_DETAILS": "Invoice {{number}} Details",
  "INVOICE_PROCESSING_TITLE": "Invoice {{number}} · Processing",

  "ISSUE_DATE": "Issue date",
  "DUE_DATE": "Due date",
  "EXCHANGE_RATE": "TL per one unit of invoice currency",
  "DESCRIPTION": "Description",
  "SOURCES": "Invoice items",
  "ADD_TO_INVOICE": "Add to invoice",
  "ADD_WORK_ORDER": "Add work order",
  "ADD_PART": "Add part",
  "CUSTOM_ITEM": "Add new item",
  "USE_Draft": "Included in another draft",

  "USE_HistoricalIssued": "Included in historical issued billing",
  "NO_PRODUCT": "No product",
  "REMOVE_LINE": "Remove line",
  "EXPAND_LINE": "Expand invoice line",
  "COLLAPSE_LINE": "Collapse invoice line",
  "QUANTITY": "Quantity",
  "UNIT_PRICE": "VAT-exclusive unit selling price",
  "UNIT_PRICE_SHORT": "Unit selling price",
  "LINE_AMOUNT": "Amount",
  "LINE_DISCOUNT": "Line discount",
  "DISCOUNT_VALUE": "Discount value",
  "DISCOUNT_RATE": "Discount rate (%)",
  "DISCOUNT_AMOUNT": "Discount amount ({{currency}})",
  "NONE": "None",
  "TEVKIFAT": "VAT withholding",
  "TEVKIFAT_FULL": "Full withholding (10/10)",
  "TEVKIFAT_FRACTION": "Apply {{fraction}} withholding",
  "TEVKIFAT_UNSUPPORTED_RATE": "{{rate}}% — select a supported rate",
  "INVALID_TEVKIFAT_RATE": "Select none, full withholding, 2/10, 3/10, 4/10, 5/10, 7/10 or 9/10.",
  "OTV": "ÖTV",
  "LINE_OTV_AMOUNT": "Whole-line ÖTV amount ({{currency}})",
  "OTV_RATE": "ÖTV (%)",
  "LINE_TOTAL": "Line total",
  "INVOICE_DISCOUNT": "Invoice discount",
  "INVOICE_ADJUSTMENTS": "Discount and withholding",
  "STOPAJ": "Income withholding",
  "TOTALS": "Totals",
  "KNOWN_SUBTOTAL": "Known subtotal",
  "DISCOUNT_TOTAL": "Discount total",
  "VAT_TOTAL": "Vat total",
  "GROSS_TOTAL": "Gross total",
  "TEVKIFAT_DEDUCTION": "VAT withholding deduction",
  "STOPAJ_DEDUCTION": "Income withholding deduction",
  "PAYABLE_TOTAL": "Amount payable",
  "CARD_PAYABLE_TOTAL": "Amount payable",
  "CARD_REMAINING_TOTAL": "Remaining amount",
  "CARD_PAID": "Paid",
  "TL_EQUIVALENT": "TL equivalent",
  "INCOMPLETE": "Complete the missing amounts to calculate the final total.",
  "SAVE_DRAFT": "Save draft",
  "ISSUE": "Officialize",
  "ISSUE_FAILED": "Processing could not start. Check the readiness messages and retry.",
  "SUMMARY": "Summary",
  "DISCARD_TITLE": "Discard changes?",
  "DISCARD_MESSAGE": "Unsaved changes will be discarded.",
  "DISCARD": "Discard",
  "KEEP_EDITING": "Keep editing",
  "CURRENCY_CHANGE": "Change invoice currency?",
  "CURRENCY_CHANGE_MESSAGE": "Prices and fixed currency amounts will be cleared. Quantities and percentage rates are kept.",
  "CONTINUE": "Continue",
  "NO_RECIPIENT": "No recipient",
  "HISTORY": "Historical billing",
  "ISSUED_AT": "Historical issue date",
  "COLLECTED_AT": "Historical collection date",
  "PAYMENT_METHOD": "Payment method",
  "NOT_ISSUED": "Not marked issued",
  "NOT_COLLECTED": "Not marked collected",
  "HISTORY_ISSUED": "Historically marked issued",
  "HISTORY_COLLECTED": "Historically marked collected",
  "STATUS_Draft": "Draft",
  "STATUS_Processing": "Processing",
  "STATUS_Failed": "Failed",

  "STATUS_Official": "Official",
} };

export const financeI18nTr = { FINANCE: {
  "BUYING_PRICE": "Alış Fiyatı (KDV Hariç)",
  "BUYING_CURRENCY": "Alış para birimi",

  "COMPLETION_TITLE": "Eksik bilgiler",
  "COMPLETION_CUSTOMER": "Müşteri bilgileri",
  "COMPLETION_INVOICE": "Fatura bilgileri",
  "COMPLETION_LINE": "Satır {{number}} · {{description}}",

  "SELECT_CUSTOMER": "Müşteri seç",
  "CUSTOMER_MULTIPLE_MATCHES": "Bu VKN/TCKN ile birden fazla müşteri var. Listeden doğru müşteriyi seçin.",
  "CHANGE_CUSTOMER": "Müşteriyi değiştir",
  "NEW_CUSTOMER": "Yeni müşteri",
  "EDIT_CUSTOMER": "Müşteriyi düzenle",
  "SAVE_CUSTOMER": "Müşteriyi kaydet",

  "PARASUT_INTEGRATION": "Paraşüt Entegrasyonu",
  "FINANCE_SERVICE_OPEN": "Finans servisi açık",
  "FINANCE_SERVICE_CLOSED": "Finans servisi kapalı",
  "FINANCE_SERVICE_CHECKING": "Finans servisi kontrol ediliyor…",
  "PARASUT_SERVER_PROBLEM": "Server Sorunu",
  "PARASUT_CONNECTION_OPEN": "Bağlantı açık",
  "PARASUT_CONNECTION_CLOSED": "Bağlantı kapalı",
  "PARASUT_CONNECTION_UNVERIFIED": "Bağlantı durumu doğrulanamadı",
  "PARASUT_SERVERS_OPEN": "Paraşüt sunucuları açık",
  "PARASUT_SERVERS_CLOSED": "Paraşüt sunucuları kapalı",
  "PARASUT_SERVERS_CHECKING": "Paraşüt sunucuları kontrol ediliyor…",
  "PARASUT_SERVERS_UNCHECKED": "Paraşüt sunucuları kontrol edilmedi",
  "PARASUT_SERVERS_UNVERIFIED": "Paraşüt sunucularının durumu doğrulanamadı",
  "PARASUT_OPEN": "Paraşüt Bağlı",
  "PARASUT_CLOSED": "Paraşüt Kapalı",
  "PARASUT_STATUS_LOADING": "Paraşüt durumu yükleniyor…",
  "PARASUT_CONNECTING": "Paraşüt’e bağlanılıyor…",
  "PARASUT_CALLBACK_CONNECTED": "Paraşüt bağlantısı kuruldu.",

  "RESOURCE_CONTACT": "Müşteri oluşturma",
  "RESOURCE_PRODUCT": "Ürün/hizmet oluşturma",
  "RESOURCE_PRODUCT_UPDATE": "Ürün/hizmet güncelleme",
  "COLLECTION_REJECTED": "Reddedildi",
  "PROVIDER_ROUTING_REQUIRED": "Faturayı kaydetmek ve e-Fatura uygunluğunu doğrulamak için alıcının VKN/TCKN bilgisini tamamlayın.",
  "PARASUT_CALLBACK_DENIED": "Paraşüt yetkilendirmesi reddedildi. Hazır olduğunuzda yeniden bağlanın.",
  "USE_Official": "Daha önce faturalandırıldı",
  "STATUS_Cancelled": "İptal edildi",
  "HISTORICAL_RECORD": "Geçmiş fatura",
  "PARASUT_NOT_CONNECTED": "Bağlı değil",
  "PARASUT_REFRESH_CATALOGUE": "Senkronize Et",
  "LOCAL_PREVIEW": "Önizleme · Kaydedilmemiş değişiklikler",
  "PROVIDER_CONFIRMED_TOTALS": "Fatura tutarları",
  "DRAFT_PENDING_TITLE": "Doğrulama bekleyen taslak isteği",
  "DRAFT_PENDING": "Taslak isteği henüz doğrulanmadı. Yeniden kaydetmeden önce sonucunu doğrulayın.",
  "DRAFT_VERIFY_NOT_APPLIED": "İsteğin uygulanmadığını doğrula ve yeniden denemek üzere serbest bırak",
  "DRAFT_RETRY_REQUIRED": "İstek uygulanmadı. Girdilerinizi kontrol edip yeniden kaydedin.",
  "DRAFT_RECOVERED": "Kaydedilen taslak doğrulandı. Sonraki değişiklikler için Kaydet düğmesini kullanın.",
  "LEGACY_LOCAL_DRAFTS": "Eski yerel taslaklar · Kontrol gerekli",
  "LEGACY_LOCAL_DRAFT_MESSAGE": "Bu taslakların kaydı henüz doğrulanmadı. İçeriklerini kontrol ederek yeniden kaydedin.",
  "PARASUT_CONNECTED": "Bağlı",
  "PARASUT_NOT_CONFIGURED": "Paraşüt erişim bilgileri sunucuda yapılandırılmalı.",
  "PARASUT_DISCONNECT_MESSAGE": "Paraşüt işlemleri duracak. Yerel taslaklar ve kayıtlı finansal geçmiş erişilebilir kalacak.",
  "PARASUT_DISCONNECT": "Bağlantıyı kes",
  "PARASUT_RECONNECT": "Yeniden bağlan",
  "PARASUT_CONNECT": "Paraşüt’e bağlan",
  "PARASUT_CONNECT_FAILED": "Paraşüt bağlantısı değiştirilemedi. Tekrar deneyin.",
  "PARASUT_LOAD_FAILED": "Paraşüt bağlantı durumu alınamadı.",
  "PARASUT_CALLBACK_FAILED": "Paraşüt yetkilendirmesi başarısız oldu veya süresi doldu. Tekrar bağlanın.",
  "PROVIDER_MANAGE_TRANSACTION": "Bu işlemi bağlı muhasebe uygulamasında yönetin",
  "RECONCILE_FAILED": "Kayıt doğrulanamadı. Kaydı bağlı muhasebe uygulamasında kontrol edin.",
  "PROVIDER_RECONCILE": "Kontrol et ve eşleştir",
  "PROVIDER_RESOURCE_ID": "Harici kayıt kimliği",
  "PROVIDER_INVOICE_ID": "Harici fatura kimliği",
  "PROVIDER_ATTENTION": "İşlemin sonucu kontrol edilmeli. Yenileyin veya bir yöneticiden kontrol etmesini isteyin.",
  "PDF_FAILED": "PDF henüz alınamıyor. Biraz sonra tekrar deneyin.",
  "DOWNLOAD_PDF": "PDF indir",
  "OTV_CODE": "ÖTV kodu",
  "TEVKIFAT_CODE": "Tevkifat kodu",
  "INVALID_TEVKIFAT_CODE": "Seçilen orana uygun bir tevkifat kodu seçin.",
  "TEVKIFAT_CONSTRUCTION": "Yapım işleri ile bu işlerle birlikte ifa edilen mühendislik, mimarlık ve etüt-proje hizmetleri",
  "TEVKIFAT_CONSULTANCY": "Etüt, plan-proje, danışmanlık, denetim ve benzeri hizmetler",
  "TEVKIFAT_MAINTENANCE": "Makine, teçhizat, demirbaş ve taşıtlara ait tadil, bakım ve onarım hizmetleri",
  "TEVKIFAT_CATERING": "Yemek servis hizmeti",
  "TEVKIFAT_ORGANIZATION": "Organizasyon hizmeti",
  "TEVKIFAT_LABOUR": "İşgücü temin hizmetleri",
  "TEVKIFAT_SECURITY": "Özel güvenlik hizmeti",
  "TEVKIFAT_BUILDING_INSPECTION": "Yapı denetim hizmetleri",
  "TEVKIFAT_TEXTILES": "Fason olarak yaptırılan tekstil ve konfeksiyon işleri, çanta ve ayakkabı dikim işleri ve bu işlere aracılık hizmetleri",
  "TEVKIFAT_TOURIST_CUSTOMERS": "Turistik mağazalara verilen müşteri bulma/götürme hizmetleri",
  "TEVKIFAT_SPORTS_RIGHTS": "Spor kulüplerinin yayın, reklam ve isim hakkı gelirlerine konu işlemleri",
  "TEVKIFAT_CLEANING": "Temizlik hizmeti",
  "TEVKIFAT_GARDENING": "Çevre ve bahçe bakım hizmetleri",
  "TEVKIFAT_SHUTTLE": "Servis taşımacılığı hizmeti",
  "TEVKIFAT_PRINTING": "Her türlü baskı ve basım hizmetleri",
  "TEVKIFAT_OTHER_SERVICES": "Diğer hizmetler [KDVGUT-(I/C-2.1.3.2.13)]",
  "TEVKIFAT_SCRAP_INGOTS": "Hurda metalden elde edilen külçe teslimleri",
  "TEVKIFAT_OTHER_INGOTS": "Hurda metalden elde edilenler dışındaki bakır, çinko, demir, çelik, alüminyum ve kurşun külçe teslimleri",
  "TEVKIFAT_METAL_PRODUCTS": "Bakır, çinko ve alüminyum ürünlerinin teslimi",
  "TEVKIFAT_METAL_PRODUCTS_WITH_LEAD": "Bakır, çinko, alüminyum ve kurşun ürünlerinin teslimi",
  "TEVKIFAT_WAIVED_EXEMPTION_SCRAP": "İstisnadan vazgeçenlerin hurda ve atık teslimi",
  "TEVKIFAT_RECYCLED_MATERIALS": "Metal, plastik, lastik, kauçuk, kâğıt ve cam hurda ve atıklardan elde edilen hammadde teslimi",
  "TEVKIFAT_RAW_FIBRES_HIDES": "Pamuk, tiftik, yün ve yapağı ile ham post ve deri teslimleri",
  "TEVKIFAT_FORESTRY": "Ağaç ve orman ürünleri teslimi",
  "TEVKIFAT_FREIGHT": "Yük taşımacılığı hizmeti [KDVGUT-(I/C-2.1.3.2.11)]",
  "TEVKIFAT_ADVERTISING": "Ticari reklam hizmetleri [KDVGUT-(I/C-2.1.3.2.15)]",
  "TEVKIFAT_OTHER_DELIVERIES": "Diğer teslimler [KDVGUT-(I/C-2.1.3.3.7)]",
  "TEVKIFAT_IRON_STEEL": "Demir-çelik ürünlerinin teslimi [KDVGUT-(I/C-2.1.3.3.8)]",
  "VAT_EXEMPTION_REASON": "KDV muafiyet açıklaması",
  "VAT_EXEMPTION_CODE": "KDV muafiyet kodu",
  "EINVOICE_INBOX": "e-Fatura gelen kutusu",
  "SCENARIO_COMMERCIAL": "Ticari",
  "SCENARIO_BASIC": "Temel",
  "EDOCUMENT_SCENARIO": "Onay süreci",
  "PROVIDER_REVIEW_REQUIRED": "Elektronik belge ayarlarını tamamlayın",
  "PROVIDER_RECIPIENT_AMBIGUOUS": "Aynı VKN/TCKN ile birden fazla aktif müşteri bulundu. Bağlı muhasebe uygulamasındaki müşteri kayıtlarını kontrol edip tekrar deneyin.",
  "PROVIDER_RECIPIENT_UNRESOLVED": "Alıcı eşleştirmesi doğrulanamadı. Alıcı bilgilerini kontrol ederek faturayı yeniden kaydedin.",
  "SELECT": "Seçiniz",
  "COLLECTION_RATE_HEADER": "Döviz kuru",
  "COLLECTION_STATUS_ACTIONS": "Durum / İşlemler",
  "COLLECTION_LEAVE_UNCERTAIN": "Tahsilat isteği tamamlanmış olabilir. Bu ekrandan çıkmak işlemi iptal etmez. Yeni bir tahsilat kaydetmeden önce tahsilat geçmişini kontrol edin.",
  "COLLECTION_RETRY": "Doğrulama bekleniyor",
  "COLLECTION_UNCERTAIN": "İşlemin sonucu doğrulanamadı. İkinci bir tahsilat oluşturmadan önce geçmişi yenileyin.",
  "COLLECTION_ACTION": "Tahsilat",
  "COLLECTION_TITLE": "Fatura {{number}} · Tahsilat",

  "COLLECTION_BACK": "Faturaya dön",
  "COLLECTION_INVOICE_TOTAL": "Fatura tutarı",
  "COLLECTION_COLLECTED": "Tahsil edilen",
  "COLLECTION_REMAINING": "Kalan",
  "COLLECTION_ACCOUNT": "Tahsilat hesabı",
  "COLLECTION_SELECT_ACCOUNT": "Hesap seç",
  "COLLECTION_DATE": "Tahsilat tarihi",
  "COLLECTION_AMOUNT": "Tahsilat tutarı {{currency}}",
  "COLLECTION_RATE": "Döviz kuru ({{from}} → {{to}})",
  "COLLECTION_SETTLEMENT": "Faturaya sayılacak tutar",
  "COLLECTION_HISTORY": "Tahsilat geçmişi",
  "COLLECTION_NO_HISTORY": "Henüz tahsilat kaydı yok.",
  "COLLECTION_LOADING": "Tahsilatlar yükleniyor…",
  "COLLECTION_PAID": "Bu faturanın tamamı tahsil edildi.",
  "COLLECTION_SAVE": "Tahsilatı kaydet",
  "COLLECTION_SAVE_FAILED": "Tahsilat işlemi tamamlanamadı. Girdiğiniz bilgiler korundu; tekrar denemeden önce geçmişi kontrol edin.",
  "COLLECTION_CONFLICT": "Tahsilatlar değişti. Tekrar denemeden önce güncel bakiye ve geçmişi kontrol edin.",
  "COLLECTION_CANCEL": "Sil",
  "COLLECTION_CANCELLED": "İptal edildi",
  "COLLECTION_CANCEL_TITLE": "Tahsilat silinsin mi?",
  "COLLECTION_CANCEL_MESSAGE": "Tahsilat tutarı faturanın kalan bakiyesine eklenecek. Kayıt işlem geçmişinde korunacak.",
  "COLLECTION_DATE_INVALID": "Fatura düzenleme tarihi ile bugün arasında bir tarih girin.",
  "COLLECTION_OVERPAYMENT": "Tahsilat, faturanın kalan bakiyesini aşamaz.",
  "COLLECTION_RELOAD": "Yeniden yükle",
  "ARCHIVE": "Arşivle",
  "ARCHIVING": "Arşivleniyor",
  "ARCHIVE_PRODUCT_TITLE": "Ürün/hizmet arşivlensin mi?",
  "ARCHIVE_PRODUCT_MESSAGE": "Bu ürün seçim listesinden kaldırılacak. Kayıtlı faturalar değişmeyecek; düzenlenebilir bir faturayı kaydetmeden veya resmileştirmeden önce bu ürünü değiştirmeniz gerekecek.",
  "ARCHIVE_UNSAVED_MESSAGE": "Ürüne ait kaydedilmemiş değişiklikleriniz kaydedilmeyecek.",
  "ARCHIVE_FAILED": "Ürün arşivlenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
  "ARCHIVE_CONFLICT": "Ürün veya etkilenen bir fatura değişti. Tekrar denemeden önce güncel bilgileri açın.",
  "PRECISION_ERROR": "En fazla {{scale}} ondalık basamak ve virgülden önce {{integerDigits}} basamak girin.",
  "DATE_ORDER_ERROR": "Vade tarihi fatura tarihinden önce olamaz.",
  "WRITE_CONFLICT": "Fatura veya bağlı iş kalemleri değişti. Güncel bilgileri kontrol edip yeniden deneyin.",
  "DELETED_DRAFT": "Bu fatura taslağı başka bir oturumda silindi. Girdileriniz korunuyor ancak bu taslak artık kaydedilemez.",
  "ADD_PRODUCT": "Ürün/hizmet ekle",
  "PRODUCT_EDITOR": "Ürün/hizmet",
  "PRODUCT_NAME": "Ürün adı",
  "CODE": "Kod",
  "OPTIONAL_CODE": "Kod (Opsiyonel)",
  "UNIT": "Birim",
  "DEFAULT_PRICE": "Satış Fiyatı",
  "CURRENCY": "Para birimi",
  "VAT_RATE": "KDV (%)",
  "person": "Kişi",
  "company": "Kurum",
  "percentage": "Yüzde (%)",
  "amount": "Sabit tutar",
  "CLOSE": "Kapat",
  "CANCEL": "Vazgeç",
  "DELETE": "Sil",
  "DELETE_INVOICE_TITLE": "Fatura taslağı silinsin mi?",
  "DELETE_INVOICE_MESSAGE": "Bu fatura taslağı silinecek. Silme işlemi geri alınamaz.",
  "DELETE_FAILED": "Fatura silinemedi. Bağlantınızı kontrol edip tekrar deneyin.",
  "DELETE_CONFLICT": "Fatura değişmiş veya taslak durumundan çıkmış. Güncel bilgilerini yükleyip tekrar deneyin.",
  "SAVE": "Kaydet",
  "SAVING": "Kaydediliyor…",
  "SAVE_FAILED": "Kaydedilemedi. Alanları ve bağlantıyı kontrol edip tekrar deneyin.",
  "PROVIDER_REQUEST_NOT_SENT": "İstek gönderilmedi. Girdiğiniz bilgiler korundu; kısa bir süre bekleyip tekrar deneyin.",
  "LOAD_FAILED": "Bilgiler yüklenemedi. Tekrar deneyin.",
  "RETRY": "Tekrar dene",
  "LOADING": "Yükleniyor…",
  "SEARCH": "Ad veya kod ara",
  "EDIT": "Düzenle",
  "UNSPECIFIED": "Belirsiz",
  "ACTIONS": "İşlemler",
  "SELECT_PRODUCT": "Ürün/hizmet seç veya oluştur",
  "PRODUCT_SERVICE": "Ürün / Hizmet",
  "INVALID_FIELD": "Bu değeri kontrol edin.",
  "DISCOUNT_EXCEEDS_BASE": "İndirim, uygulandığı tutardan fazla olamaz.",
  "CALCULATION_TOO_LARGE": "Girilen tutarlar desteklenen hesaplama sınırını aşıyor.",
  "REQUIRED_FIELD": "Bu alanı tamamlayın: {{field}}.",
  "WORK_ORDER_NOT_APPROVED": "Fatura resmileştirilmeden önce {{field}} numaralı iş emri ekspertiz tarafından onaylanmalı.",
  "RECIPIENT": "Faturanın kesileceği kişi / kurum",
  "PARTY_TYPE": "Alıcı türü",
  "RECIPIENT_NAME": "Ad Soyad / Ünvan",
  "TAX_NUMBER": "Vergi / Kimlik Numarası",
  "RECIPIENT_ABROAD": "Alıcı yurt dışında mı?",
  "NO": "Hayır",
  "YES": "Evet",
  "TAX_OFFICE": "Vergi dairesi",
  "PHONE_COUNTRY_CODE": "Telefon ülke kodu",
  "PHONE_COUNTRY_ISO": "Telefon ülke kısaltması",
  "PHONE": "Telefon",
  "EMAIL": "E-posta",
  "ADDRESS": "Adres",
  "CITY": "İl",
  "DISTRICT": "İlçe",
  "POSTAL_CODE": "Posta kodu",
  "COUNTRY": "Ülke",
  "INVOICES": "Faturalar",
  "INVOICE_NUMBER": "Fatura {{number}}",
  "ITEM_COUNT": "{{count}} kalem",
  "CREATE_DRAFT": "Taslak Fatura Oluştur",
  "INVOICE_EDITOR": "Fatura {{number}} · Taslağı Düzenle",
  "INVOICE_DETAILS": "Fatura {{number}} Detayları",
  "INVOICE_PROCESSING_TITLE": "Fatura {{number}} · Resmileştiriliyor",

  "ISSUE_DATE": "Fatura tarihi",
  "DUE_DATE": "Vade tarihi",
  "EXCHANGE_RATE": "1 birim döviz için TL kuru",
  "DESCRIPTION": "Açıklama",
  "SOURCES": "Fatura Kalemleri",
  "ADD_TO_INVOICE": "Faturaya ekle",
  "ADD_WORK_ORDER": "İş Emrini Ekle",
  "ADD_PART": "Parçayı Ekle",
  "CUSTOM_ITEM": "Yeni Kalem Ekle",
  "USE_Draft": "Başka taslakta yer alıyor",

  "USE_HistoricalIssued": "Geçmiş kesilmiş kayıtta yer alıyor",
  "NO_PRODUCT": "Ürün seçilmedi",
  "REMOVE_LINE": "Satırı kaldır",
  "EXPAND_LINE": "Fatura satırını genişlet",
  "COLLAPSE_LINE": "Fatura satırını daralt",
  "QUANTITY": "Miktar",
  "UNIT_PRICE": "KDV hariç birim satış fiyatı",
  "UNIT_PRICE_SHORT": "Birim satış fiyatı",
  "LINE_AMOUNT": "Tutar",
  "LINE_DISCOUNT": "Satır indirimi",
  "DISCOUNT_VALUE": "İndirim değeri",
  "DISCOUNT_RATE": "İndirim oranı (%)",
  "DISCOUNT_AMOUNT": "İndirim tutarı ({{currency}})",
  "NONE": "Yok",
  "TEVKIFAT": "Tevkifat",
  "TEVKIFAT_FULL": "Tümüne tevkifat uygula (10/10)",
  "TEVKIFAT_FRACTION": "{{fraction}} tevkifat uygula",
  "TEVKIFAT_UNSUPPORTED_RATE": "%{{rate}} — desteklenen bir oran seçin",
  "INVALID_TEVKIFAT_RATE": "Yok, tümüne tevkifat, 2/10, 3/10, 4/10, 5/10, 7/10 veya 9/10 seçeneklerinden birini seçin.",
  "OTV": "ÖTV",
  "LINE_OTV_AMOUNT": "Satır ÖTV tutarı ({{currency}})",
  "OTV_RATE": "ÖTV (%)",
  "LINE_TOTAL": "Brüt satır toplamı",
  "INVOICE_DISCOUNT": "Fatura indirimi",
  "INVOICE_ADJUSTMENTS": "İndirim ve Stopaj",
  "STOPAJ": "Stopaj",
  "TOTALS": "Toplamlar",
  "KNOWN_SUBTOTAL": "Bilinen ara toplam",
  "DISCOUNT_TOTAL": "Toplam indirim",
  "VAT_TOTAL": "KDV toplamı",
  "GROSS_TOTAL": "Brüt fatura toplamı",
  "TEVKIFAT_DEDUCTION": "Tevkifat kesintisi",
  "STOPAJ_DEDUCTION": "Stopaj kesintisi",
  "PAYABLE_TOTAL": "Ödenecek tutar",
  "CARD_PAYABLE_TOTAL": "Ödenecek Tutar",
  "CARD_REMAINING_TOTAL": "Kalan Tutar",
  "CARD_PAID": "Ödendi",
  "TL_EQUIVALENT": "TL karşılığı",
  "INCOMPLETE": "Kesin toplam için eksik tutarları tamamlayın.",
  "SAVE_DRAFT": "Taslağı kaydet",
  "ISSUE": "Resmileştir",
  "ISSUE_FAILED": "İşlem başlatılamadı. Hazırlık mesajlarını kontrol edip tekrar deneyin.",
  "SUMMARY": "Kayıtlı özet PDF",
  "DISCARD_TITLE": "Değişikliklerden vazgeçilsin mi?",
  "DISCARD_MESSAGE": "Kaydedilmemiş değişiklikler silinecek.",
  "DISCARD": "Vazgeç",
  "KEEP_EDITING": "Düzenlemeye devam et",
  "CURRENCY_CHANGE": "Fatura para birimi değişsin mi?",
  "CURRENCY_CHANGE_MESSAGE": "Fiyatlar ve sabit tutarlar temizlenir. Miktarlar ve yüzde oranları korunur.",
  "CONTINUE": "Devam et",
  "NO_RECIPIENT": "Alıcı girilmedi",
  "HISTORY": "Geçmiş Faturalandırma",
  "ISSUED_AT": "Geçmiş kesim tarihi",
  "COLLECTED_AT": "Geçmiş tahsilat tarihi",
  "PAYMENT_METHOD": "Geçmiş ödeme yöntemi",
  "NOT_ISSUED": "Kesildi olarak işaretlenmemiş",
  "NOT_COLLECTED": "Tahsil edildi olarak işaretlenmemiş",
  "HISTORY_ISSUED": "Geçmişte kesildi olarak işaretli",
  "HISTORY_COLLECTED": "Geçmişte tahsil edildi olarak işaretli",
  "STATUS_Draft": "Taslak",
  "STATUS_Processing": "Resmileştiriliyor",
  "STATUS_Failed": "Başarısız",

  "STATUS_Official": "Resmi",
} };
